/**
 * WebGL detection utilities for the 3D/2D branch scene path selection.
 *
 * AC:1 (v8-4-2):
 * - supportsWebGL(): tries webgl2 then webgl context; returns false if neither available
 * - isLowCapabilityDevice(): heuristic — hardwareConcurrency < 4
 */

/**
 * Returns true if the browser supports WebGL (webgl2 or webgl).
 * Catches any exception that may occur in sandboxed/restricted environments.
 */
export const supportsWebGL = (): boolean => {
  try {
    const canvas = document.createElement('canvas');
    return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
  } catch {
    return false;
  }
};

/**
 * Returns true if the device is considered low-capability.
 * Uses navigator.hardwareConcurrency as a simple CPU-core heuristic.
 * Devices with fewer than 4 cores are flagged as low-capability.
 */
export const isLowCapabilityDevice = (): boolean =>
  typeof navigator !== 'undefined' && (navigator.hardwareConcurrency ?? 4) < 4;
